// eslint-disable-next-line no-undef
const nav = document.querySelector('.dropdown-menu-nav');
// eslint-disable-next-line no-undef
const dropdown = document.querySelector('.navigation--dropdown-menu');
if (dropdown) {
  // eslint-disable-next-line no-use-before-define
  dropdown.addEventListener('click', toggle_dropdown_menu);
}
// eslint-disable-next-line camelcase,no-undef
const menu_icon_default = document.querySelector('.dropdown-inactive-svg');
// eslint-disable-next-line camelcase,no-undef
const menu_icon_active = document.querySelector('.dropdown-active-svg');

// eslint-disable-next-line camelcase
function toggle_dropdown_menu() {
  if (!nav || !menu_icon_default || !menu_icon_active) return;
  if (nav.style.display === 'flex') {
    nav.style.display = 'none';
    menu_icon_default.style.display = 'flex';
    menu_icon_active.style.display = 'none';
  } else {
    nav.style.display = 'flex';
    menu_icon_default.style.display = 'none';
    menu_icon_active.style.display = 'flex';
  }
}

/**
 * Menu Navigation Behavior.
 * Handles toggling of mobile and desktop submenus.
 */
(function (Drupal) {
  Drupal.behaviors.menuNav = {
    attach: function (context) {
      const menuItems = context.querySelectorAll(
        '.nav-mobile__item--has-children, .nav-desktop__item--has-children',
      );

      menuItems.forEach((row) => {
        const heading = row.querySelector('.nav-mobile__heading, .nav-desktop__heading');
        const link = row.querySelector('.nav-mobile__link, .nav-desktop__link');

        link.addEventListener('click', (e) => {
          e.stopPropagation();
        });

        heading.addEventListener('click', (e) => {
          e.preventDefault();
          row.classList.toggle('is-open');
        });
      });
    },
  };
})(Drupal);

/**
 * Menu Toggle Behavior
 * Handles showing and hiding the menu while changing fontawesome icon
 */
(function (Drupal) {
  Drupal.behaviors.toggleMenu = {
    attach: function (context) {
      const toggleBtn = context.querySelector('.site-header__cta--mobile');
      const menu = context.querySelector('.nav-mobile');

      if (!toggleBtn || !menu) return;

      const icon = toggleBtn.querySelector('.site-header__icon-group i');

      const openMenu = () => {
        const scrollY = window.scrollY;
        document.body.dataset.scrollY = scrollY;

        document.body.classList.add('nav-mobile-open');
        document.body.style.top = `-${scrollY}px`;

        toggleBtn.classList.add('is-active');
        menu.classList.add('is-visible');

        icon.classList.remove('fa-bars');
        icon.classList.add('fa-xmark');
      };

      const closeMenu = () => {
        const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);

        document.body.classList.remove('nav-mobile-open');
        document.body.style.top = '';
        delete document.body.dataset.scrollY;

        toggleBtn.classList.remove('is-active');
        menu.classList.remove('is-visible');

        icon.classList.remove('fa-xmark');
        icon.classList.add('fa-bars');

        window.scrollTo(0, scrollY);
      };

      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = menu.classList.contains('is-visible');

        if (isOpen) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    },
  };
})(Drupal);
